module.exports = __webpack_public_path__ + "img/20230109172727.0741318c.jpg";